export default {
  recordTitle: '充值记录',
  detailTitle: '交易详情',
  empty: '该筛选下暂无充值记录',
  filterType: '充值类型',
  filterStatus: '充值状态',
  filterTime: '充值时间',
  type: {
    all: '全部',
    ewallet: '数字钱包',
    crypto: '虚拟货币',
    alipay: '支付宝',
    wechat: '微信',
    bank: '银行卡',
    unionpay: '云闪付',
  },
  st: {
    all: '全部',
    paid: '已入账',
    pending: '待支付',
    confirming: '确认中',
    expired: '已超时',
    cancelled: '已取消',
  },
  detailChannel: '充值渠道',
  detailNote: '说明',
  detailTime: '时间',
  detailId: '流水号',
  detailCurrency: '币种账户',
  detailPayAmount: '支付金额',
  detailBonus: '加赠',
  detailRate: '锁定汇率',
  detailNetwork: '网络',
  detailAddress: '充值地址',
  detailConfirmations: '确认数',
  detailTxHash: '交易哈希',
  detailBankName: '收款银行',
  detailAccountName: '收款户名',
  detailAccountNumber: '收款卡号',
  detailMemo: '转账附言',
  detailExpireAt: '过期时间',
  detailTypeKey: '充值类型',
  contactSupport: '联系客服',
  rechargeRecord: '充值记录',
  payment: '支付',
  exchangeRate: '汇率',
  confirmationsText: '{count} 确认',

  // Balance
  balanceLabel: '我的余额',
  withdraw: '提现',

  // Marquee
  marqueeBanner: '🔊 新用户首存好礼 · 每日首充有礼 · 虚拟币首次入款加赠 · 点击查看全部活动 ›',

  // Type / Channel labels
  typeCrypto: '虚拟货币',
  typeEwallet: '数字钱包',
  channelThirdParty: '(三方)',

  // Order Pending - typeChannel prop
  typeChannelCryptoOfficial: '虚拟货币 · USDT(官方)',
  typeChannelBankTransfer: '银行卡 · 银行卡转账',
  typeChannelDefault: '数字钱包',

  // Order Pending - paymentMethod prop
  paymentMethodOnchain: '虚拟货币 · 链上充值',
  paymentMethodBankPlatform: '银行卡 · 银行卡转账(平台)',

  // Order Success
  walletNameCNY: 'CNY 钱包',
  walletNameUSDT: 'USDT 钱包',
  orderSuccessHint:
    '已发 DepositSucceeded(06 成长值 / 09 活动进度联动)· 活动奖励另计,请到奖励中心领取',

  // Order Unfinished
  orderUnfinishedTitle: '该订单未完成',
  orderUnfinishedSubtitle: '通道拥堵?已为你推荐成功率更高的渠道',
  retryCrypto: '换 USDT(官方) 重新下单',
  retryEwallet: '换 OKPAY 重新下单',

  // Tips
  tipsTitle: '温馨提示',
  tip1: '到账时间:法币通道 1–5 分钟;USDT 按网络确认(TRC-20 约 1 分钟)· 按实收金额入账;',
  tip2: '请使用本人账户支付,金额须与订单一致,请勿重复提交、修改金额或超时支付;',
  tip3: '跨币种充值汇率<b>下单即锁定</b>,订单超时 / 取消后失效,需重新下单询价;',
  tip4: '<b>渠道加赠与充值活动奖励可叠加</b>:加赠随充值直接入账,活动奖励请到「优惠 / 奖励中心」领取;',
  tip5: '<b>三方渠道</b>(数字钱包/支付宝/微信/云闪付)下单后跳转外部收银台完成支付;<b>平台自有渠道</b>(银行卡转账 / USDT·ETH·BTC 官方链上)在本页生成收款信息;',
  tip6: '充值未到账请携订单号联系在线客服;维护中的渠道将自动隐藏。',

  // CTA Button
  ctaGetAccount: '获取收款账户',
  ctaGenerateOrder: '生成充值订单',
  ctaRecharge: '立即充值',

  // Embedded wallet deposit (VIPPAY 等 pay_flow=embedded)
  embeddedPhoneLabel: '钱包手机号',
  embeddedPhonePlaceholder: '请输入钱包注册手机号',
  embeddedPasswordLabel: '钱包安全密码',
  embeddedPasswordPlaceholder: '请输入钱包安全密码',
  embeddedPasswordHint: '安全密码仅用于本次划转，不会被保存或记录',
  embeddedConfirming: '划转中…',
  embeddedSuccess: '划转成功，已入账',
  embeddedErrPhone: '请输入正确的 11 位手机号',
  embeddedErrPassword: '请输入钱包安全密码',
  embeddedErrAmount: '金额格式不合法',
  embeddedErrRange: '金额需在 {min} ~ {max} 之间',
  embeddedFailWarn:
    '划转失败，上一笔结果可能未确认。请勿重复提交，否则可能被扣两次；如有疑问请联系客服。',
  embeddedRestricted: '账号已被限制充值，如有疑问请联系客服。',

  // Embedded wallet gate popups (VIPPAY 等)
  gatePhoneTitle: '使用 VIPPAY 前请先绑定手机号',
  gatePhoneDesc: '绑定后将直接使用该手机号登录 VIPPAY，无需再次输入账号或密码。',
  gatePhoneCta: '去绑定手机号',
  gateCancel: '取消',
  gateFundTitle: '本站账号需先设置资金密码',
  gateFundDesc:
    '使用本站绑定手机号快捷登录，需要先在安全中心设置资金密码；也可直接登录其他 VIPPAY 账号。',
  gateFundInfo: '本站账号设置一次即可，确认支付时无需再次输入资金密码。',
  gateFundCta: '去设置资金密码',
  gateFundManual: '+ 手动输入其他账号登录',
  gateFundManualDesc: '其他账号无需设置本站资金密码；每次登录仍需输入该账号的密码。',

  // 图2：选择 VIPPAY 登录账号（绑定手机后 / 已设资金密码）
  gateAccountTitle: '选择 VIPPAY 登录账号',
  gateAccountDesc: '使用本站绑定账号，或选择曾登录的其他账号',
  gateAccountBound: '本站绑定手机号',
  gateAccountFree: '免输入密码',
  gateAccountManualDesc: '其他账号每次需输入密码；原型仅记住手机号，不主动保存密码。',
  gateAccountCta: '确认使用并继续',
  // 图3：登录其他 VIPPAY 账号
  gateManualBack: '返回选择账号',
  gateManualTitle: '登录其他 VIPPAY 账号',
  gateManualDesc: '输入该账号的手机号和密码，本次充值使用此账号支付。',
  gateManualPhoneLabel: 'VIPPAY 手机号',
  gateManualPhonePh: '请输入 11 位手机号',
  gateManualPwdLabel: '登录密码',
  gateManualPwdPh: '请输入该账号密码',
  gateManualHint: '原型仅模拟登录，不校验第三方真实密码；不会主动保存密码。',
  gateManualCta: '登录并继续',

  // 最近使用的其他账号
  gateRecentTitle: '最近使用的其他账号',
  gateRecentLogin: '输入密码登录',

  // 图1：VIPPAY 安全支付页（其他账号）
  gatePayTitle: 'VIPPAY',
  gatePayHeading: 'VIPPAY 安全支付',
  gatePaySub: '已使用其他 VIPPAY 账号登录',
  gatePaySubSystem: '使用本站绑定手机号快捷登录',
  gatePayOtherAccount: '其他账号',
  gatePaySystemAccount: '本站账号',
  gatePayLockedTag: '本单已锁定',
  gatePayAmountLabel: '本次支付金额',
  gatePayOrderLabel: '商户订单',
  gatePayArriveLabel: '预计到账',
  gatePayLockHint: '本单支付账号已锁定；如需切换,请返回并取消订单后重新选择',
  gatePayCta: '确认支付',
  gatePayDoing: '确认中…',
  gatePayFooter: '支付信息由 VIPPAY 加密处理，支付结果以商户到账通知为准。',

  // Amount text (with interpolation)
  arrivedApprox: '到账约 {amount}',
  arrivedWithBonus: '到账约 {amount},含加赠 {bonus}',

  // Rate text
  rateCnyToUsdt: '1 CNY ≈ {rate} USDT',
  rateCryptoToUsdt: '1 {currency} ≈ {rate} USDT',
  rateCryptoToCny: '1 {currency} ≈ ¥{rate}',

  // Mock bank data
  bankName: '招商银行',
  accountName: '王*成',
  confirmCount: '{count} 个确认',
  cryptoNote: '按实收金额入账 · 请勿向该地址转入其他币种 · {count} 个确认 ≈ 1 分钟(docs 03 形态③)',

  // RechargeForm - Section titles
  rechargeType: '充值类型',
  rechargeChannel: '充值渠道',
  channelWindow: '每日可用时段 {window}',
  rechargeAmount: '充值金额',

  // RechargeForm - Labels & placeholders
  depositLabel: '存款金额',
  enterAmountPlaceholder: '请输入充值金额',
  selectChannelFirst: '请选择充值渠道',

  // RechargeForm - Range text (with interpolation)
  rangeFmtCrypto: '可充值区间 {min} {currency} – {max} {currency}({name})',
  rangeFmtFiat: '可充值区间 ¥{min} – ¥{max}({name})',

  // RechargeForm - Error messages
  minRechargeError: '最低充值金额 ¥{min}',
  maxRechargeError: '最高充值金额 ¥{max}',

  // RechargeForm - Get amount label
  getAmountWithBonus: '💰 获得金额(含渠道加赠 {bonus})',
  getAmountNoBonus: '💰 获得金额(入账至当前钱包)',

  // RechargeForm - Rate text
  rateReference: '参考汇率 {from} ≈ {to} · 下单后锁定本单汇率,订单关闭即失效',

  // Recharge type labels (keyed by type key)
  typeLabel_ewallet_name: '数字钱包',
  typeLabel_ewallet_subtitle: '笔笔加赠',
  typeLabel_ewallet_tag: '推荐',
  typeLabel_crypto_name: '虚拟货币',
  typeLabel_crypto_subtitle: '链上直充',
  typeLabel_crypto_tag: '安全',
  typeLabel_alipay_name: '支付宝',
  typeLabel_alipay_subtitle: '一键支付',
  typeLabel_alipay_tag: '极速',
  typeLabel_wechat_name: '微信',
  typeLabel_wechat_subtitle: '方便快捷',
  typeLabel_wechat_tag: '稳定',
  typeLabel_bank_name: '银行卡',
  typeLabel_bank_subtitle: '大额转账',
  typeLabel_bank_tag: '稳定',
  typeLabel_unionpay_name: '云闪付',
  typeLabel_unionpay_subtitle: '银联扫码',
  typeLabel_unionpay_tag: '稳定',

  // Channel names (keyed by channel id, Chinese-named channels only)
  channelName_4: '波币',
  channelName_5: 'NO钱包',
  channelName_7: '万币',
  channelName_9: 'K豆',
  channelName_11: '808钱包',
  channelName_12: '365钱包',
  channelName_13: 'HD钱包',
  channelName_14: 'C币钱包',
  channelName_15: 'SPAY钱包',
  channelName_16: 'TGPAY钱包',
  channelName_101: 'USDT(官方)',
  channelName_102: 'USDT扫码',
  channelName_103: 'USDT转账',
  channelName_104: 'USDT大额',
  channelName_105: 'USDT小额',
  channelName_106: 'ETH扫码',
  channelName_107: 'ETH大额',
  channelName_108: 'BTC扫码',
  channelName_109: 'BTC大额',
  channelName_201: '小额支付宝1',
  channelName_202: '小额支付宝2',
  channelName_203: '支付宝扫码',
  channelName_204: '大额支付宝',
  channelName_205: '支付宝金条',
  channelName_301: '小额微信1',
  channelName_302: '小额微信2',
  channelName_303: '微信扫码',
  channelName_304: '大额微信',
  channelName_401: '银行卡转账',
  channelName_501: '云闪付扫码',
  channelName_502: '云闪付转卡',

  // Channel iconText (keyed by iconKey, shared keys for same icon)
  channelIcon_1: 'VIP',
  channelIcon_2: 'GO',
  channelIcon_3: 'OK',
  channelIcon_4: '波',
  channelIcon_5: 'NO',
  channelIcon_6: 'TO',
  channelIcon_7: '万',
  channelIcon_8: 'U',
  channelIcon_9: 'K豆',
  channelIcon_10: 'JJ',
  channelIcon_808: '808',
  channelIcon_365: '365',
  channelIcon_HD: 'HD',
  channelIcon_alipay: '支',
  channelIcon_wechat: '微',
  channelIcon_bank: '银',
  channelIcon_unionpay: '闪',

  // OrderPending - Titles & labels
  orderPendingTitle: '订单待支付',
  orderIdLabel: '单号',
  amountLabel: '支付金额',
  typeChannelLabel: '类型 · 通道',
  paymentMethodLabel: '支付方式',
  lockedRateLabel: '汇率锁定',
  remainingTimeLabel: '剩余支付时间',

  // OrderPending - Bank info labels
  bankNameLabel: '收款银行',
  accountNameLabel: '收款户名',
  cardNumberLabel: '收款卡号',
  transferAmountLabel: '转账金额(含识别尾数)',
  transferRemarkLabel: '转账附言(必填)',

  // OrderPending - Crypto info labels
  networkLabel: '网络',
  depositAddressLabel: '充值地址',
  confirmCountLabel: '确认数',

  // OrderPending - Buttons & actions
  copyBtn: '复制',
  waitingConfirming: '等待入账确认',
  doneTransfer: '我已完成转账',
  donePayment: '我已完成支付',
  cancelOrder: '取消订单',
  reopenPayment: '重新打开支付页',
  reopenVippay: '打开 VIPPAY',
  orderCancelled: '订单已取消',
  orderPaid: '订单已入账',
  orderExpired: '订单已超时',
  orderTransferredSuccess: '已确认转账,等待入账',
  orderTransferredFailed: '操作失败,请重试',
  orderRechargeTimeout: '支付未确认，请确认是否转账成功',
  orderCancelledBySystem: '订单已取消',
  orderCannotBeCancelled: '该订单支付已确认不可关闭',

  // OrderSuccess - Labels & text
  orderSuccessTitle: '充值成功',
  orderCredited: '已到账',
  creditedAmountLabel: '入账金额',
  creditedWalletLabel: '入账钱包',
  doneBtn: '完成',

  // OrderPending - Notes / hints
  bankNote:
    '请使用本人银行卡按「含识别尾数金额」足额转账并填写附言 8866(双保险自动核销,docs 03 形态②)',
  thirdPartyNote: '已在新窗口打开三方收银台,支付完成后回本页等待入账;未弹出?',

  // WithdrawForm - Titles & labels
  withdrawRecords: '提现记录',
  withdrawAmountLabel: '提现金额',
  withdrawablePrefix: '可提现',
  withdrawTo: '提现到',
  selectWithdrawAccount: '请选择提现账户',
  accountTypeHint: '数字钱包 / 加密货币 / 银行卡 / 支付宝',
  changeAccount: '更换',
  allBtn: '全部',

  // WithdrawForm - Fee card
  feeLabel: '手续费',
  feeLabelRate: '手续费({rate}%)',
  feeFree: '免费',
  estimatedArrival: '预计到账',
  refRate: '参考汇率',
  choosePayoutHint: '选择到账方式后,计算手续费与到账',

  // WithdrawForm - Hints
  withdrawHintTop: '最快 5-10 分钟到账 · 单笔最低',
  withdrawMinUsdt: '20 USDT',
  withdrawMinCny: '¥100',
  withdrawHintBottom: '请仔细核对收款信息,转入他人账户将无法追回',

  // WithdrawForm - Button & errors
  confirmWithdraw: '确认提现',
  selectAccountFirst: '请选择提现账户',
  errEnterWithdrawAmount: '请输入提现金额',
  errWithdrawBelowMin: '单笔最低提现 {amount}',
  errSelectWithdrawAccount: '请选择提现账户',
  errNeedKyc: '该账户需完成实名认证后方可提现',
  // 金额校验联动：行内红字 / 按钮态 / 超额 toast
  withdrawBelowMinGap: '还差 {amount} 起提',
  withdrawMinOnly: '单笔最低 {amount}',
  withdrawOverBalance: '超出可提现金额',
  errWithdrawOverBalance: '可提现金额不足，当前最多可提 {amount}',

  // WithdrawForm - Account display prefixes
  accountPrefixEwallet: '数字钱包',
  accountPrefixCrypto: '加密货币',
  accountPrefixBank: '银行卡',
  accountPrefixAlipay: '支付宝',

  // WithdrawResult - Titles & text
  withdrawResultTitle: '提现结果',
  withdrawSubmitted: '提现申请已提交',
  withdrawArrivingSoon: '⚡ 预计 5-10 分钟到账',
  accountCreditedLabel: '到账账户',
  statusLabel: '当前状态',
  statusProcessing: '处理中',
  estimatedArrivalTime: '预计到账',
  arrivalInTime: '· 5-10 分钟内',
  flowIdLabel: '流水号',
  viewWithdrawRecords: '查看提现记录',

  // KYC - Title & guide
  kycTitle: '实名认证',
  kycGuideTitle: '🛡 为什么需要实名认证?',
  kycGuide1: '· 应监管与反洗钱(AML)要求,平台须核验用户真实身份',
  kycGuide2: '· 保障账户与资金安全:<b>提现收款账户须与实名一致</b>',
  kycGuide3: '· 信息加密存储,仅用于合规核验,不作任何其他用途',

  // KYC - Labels & placeholders
  kycDocumentType: '证件类型',
  kycIdCard: '居民身份证',
  kycPassport: '护照',
  kycRealName: '真实姓名',
  kycRealNamePlaceholder: '与证件姓名一致(2–20 位中文)',
  kycIdNumber: '身份证号码',
  kycPassportNumber: '护照号码',
  kycIdNumberPlaceholder: '18 位身份证号(末位可为 X)',
  kycPassportPlaceholder: '8-9 位护照号码',
  kycExpiryDate: '证件有效期',
  kycExpiryPlaceholder: '2030-12-31',
  kycLongTerm: '长期有效',
  kycDocumentPhotos: '证件照片',

  // KYC - Photo tiles
  kycIdPortrait: '身份证 · 人像面',
  kycIdEmblem: '身份证 · 国徽面',
  kycPassportData: '护照 · 资料页',
  kycSelfie: '手持证件照',
  kycUploadHint: '拍摄或从相册上传',
  kycReupload: '重新上传',
  kycUploading: '上传中…',

  // KYC - Requirements & agreement
  kycPhotoRequirement:
    '要求:证件边框完整 · 字迹清晰 · 无反光遮挡 · 单张 ≤ 5MB;手持照需本人面部与证件信息同框清晰',
  kycAgreeText:
    '我已阅读并同意<a href="#" class="link-inline" data-nav="privacy">《隐私政策》</a>,授权平台将以上信息用于身份核验',

  // KYC - Submit button
  kycSubmit: '提交认证',
  kycSubmitting: '提交中…',
  kycDemoTag: '原型模拟',
  kycDemoBar: '账户已下发 kycRequired',
  kycDemoFill: '填入演示资料',
  kycDemoFilled: '已填入模拟认证资料',

  // KYC - Processing state
  kycProcessingTitle: '实名信息审核中',
  kycProcessingDesc: '预计 1–3 分钟完成(OCR 识别 + 人工复核兜底)',
  kycProcessingDesc2: '审核通过将自动通知,并自动继续本次提现',
  kycProcessingNotify: '审核通过将自动通知',
  kycSubmitted: '已提交,进入审核(OCR + 人工兜底)',

  // KYC - 提现页状态卡片
  kycCardTitle: '账户安全认证',
  kycCardDesc: '该账户提现前需完成实名认证',
  kycGoVerify: '去认证',
  kycVerifiedTag: '已认证',
  kycPendingTag: '审核中',
  kycRejectedTag: '未通过',

  // KYC - 驳回页（/kyc/details rejected）
  kycRejectedTitle: '审核未通过',
  kycRejectedDesc: '请根据原因修正后重新提交,已填信息已为你保留',
  kycRejectedReason: '驳回原因:',
  kycResubmit: '重新提交',
  kycCardSubApproved: '已完成实名认证',
  kycCardSubPending: '认证资料审核中，预计 1–3 工作日',
  kycCardSubRejected: '认证未通过，请修改后重新提交',

  // KYC - 已认证详情页
  kycDetailTitle: '已完成实名认证',
  kycDetailDesc1: '实名信息已加密存储并锁定',
  kycDetailDesc2: '提现收款账户须与实名一致;如需变更请联系在线客服',
  kycDetailDocType: '证件类型',
  kycDetailRealName: '真实姓名',
  kycDetailIdNumber: '证件号码',
  kycDetailExpiry: '证件有效期',

  // KYC - Processing card labels
  kycMaskedNameLabel: '真实姓名',
  kycMaskedNumberLabel: '证件号码',
  kycMaskedIdTypeLabel: '证件类型',
  kycMaskedExpiryLabel: '证件有效期',

  // KYC - Error messages
  kycErrName: '姓名须为 2–20 位中文(可含「·」)',
  kycErrIdNumber: '身份证号码不正确,请核对后重填',
  kycErrPassportNumber: '护照号应为 8–9 位字母或数字',
  kycErrExpiryInvalid: '请填写证件有效期(如 2030-12-31)或勾选长期有效',
  kycErrExpiryExpired: '证件已过期,无法通过认证',
  kycErrUploadAllId: '请上传全部证件照片(人像面、国徽面与手持证件照)',
  kycErrUploadAllPassport: '请上传全部证件照片(资料页与手持证件照)',
  kycErrAgree: '请阅读并勾选《隐私政策》授权',
  kycErrFileType: '仅支持 JPG、PNG、WebP 格式的照片',
  kycErrFileSize: '照片不能超过 5MB,请重新选择',
  kycErrUploading: '照片上传失败,请重新选择',
  kycErrPhotoPending: '照片上传中,请稍候再提交',
  kycErrRejected: '上次审核未通过,请修改资料后重新提交',
}
